import { render, staticRenderFns } from "./detailBidsDialog.vue?vue&type=template&id=01a9c3c7&scoped=true"
import script from "./detailBidsDialog.vue?vue&type=script&lang=js"
export * from "./detailBidsDialog.vue?vue&type=script&lang=js"
import style0 from "./detailBidsDialog.vue?vue&type=style&index=0&id=01a9c3c7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a9c3c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a9c3c7')) {
      api.createRecord('01a9c3c7', component.options)
    } else {
      api.reload('01a9c3c7', component.options)
    }
    module.hot.accept("./detailBidsDialog.vue?vue&type=template&id=01a9c3c7&scoped=true", function () {
      api.rerender('01a9c3c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ustnFinance/auction/placeBid/detail/detailBidsDialog.vue"
export default component.exports